export default __webpack_public_path__ + "static/media/2.70410508.svg";